var _g, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1449 34H57.3859C60.2539 34 62.8279 31.918 63.1169 29.064C63.4479 25.789 60.8559 23 57.6449 23H38.3149C36.6909 23 35.2339 21.784 35.1499 20.161C35.0589 18.431 36.4349 17 38.1449 17H43.3859C46.2539 17 48.8279 14.918 49.1169 12.064C49.4479 8.789 46.8559 6 43.6449 6H32.1449H24.6449H9.64491C6.60691 6 4.14491 8.462 4.14491 11.5C4.14491 14.538 6.60691 17 9.64491 17H13.1449C14.2499 17 15.1449 17.895 15.1449 19C15.1449 20.105 14.2499 21 13.1449 21H5.85691C3.50991 21 1.40391 22.704 1.16791 25.038C0.896913 27.718 3.01791 30 5.64491 30H11.9749C13.5989 30 15.0559 31.216 15.1399 32.839C15.2309 34.569 13.8549 36 12.1449 36H8.85691C6.50991 36 4.40391 37.704 4.16791 40.038C3.89791 42.718 6.01791 45 8.64491 45H13.0379C14.0339 45 14.9579 45.681 15.1179 46.664C15.3209 47.917 14.3599 49 13.1449 49H8.85691C6.50991 49 4.40391 50.704 4.16791 53.038C3.89691 55.718 6.01791 58 8.64491 58H30.6449C30.7309 58 30.8109 57.979 30.8949 57.975C30.9789 57.982 31.0589 58 31.1449 58H48.5309C50.2009 58 51.7259 56.878 52.0679 55.243C52.5369 52.998 50.8129 51 48.6449 51H43.2519C42.2559 51 41.3319 50.319 41.1719 49.336C40.9689 48.083 41.9299 47 43.1449 47H55.4329C57.7799 47 59.8859 45.296 60.1219 42.961C60.3919 40.282 58.2719 38 55.6449 38H52.2519C51.2559 38 50.3319 37.319 50.1719 36.336C49.9689 35.083 50.9299 34 52.1449 34Z",
    fill: "url(#paint0_radial_4090:49428)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3922 32.3929L23.0095 25.3559C22.8561 25.2409 22.7317 25.0918 22.646 24.9204C22.5602 24.7489 22.5156 24.5599 22.5156 24.3682V18.8127C22.5156 18.4853 22.6457 18.1712 22.8772 17.9397C23.1087 17.7082 23.4228 17.5781 23.7502 17.5781H41.0341C41.3616 17.5781 41.6756 17.7082 41.9071 17.9397C42.1386 18.1712 42.2687 18.4853 42.2687 18.8127V24.3129C42.2687 24.5038 42.2245 24.692 42.1394 24.8629C42.0544 25.0338 41.9309 25.1826 41.7786 25.2977L32.3922 32.3929Z",
    stroke: "#2F189C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3922 32.3945L23.0095 39.4316C22.8561 39.5466 22.7317 39.6957 22.646 39.8671C22.5602 40.0385 22.5156 40.2276 22.5156 40.4192V45.9748C22.5156 46.3022 22.6457 46.6162 22.8772 46.8478C23.1087 47.0793 23.4228 47.2093 23.7502 47.2093H41.0341C41.3616 47.2093 41.6756 47.0793 41.9071 46.8478C42.1386 46.6162 42.2687 46.3022 42.2687 45.9748V40.4746C42.2687 40.2837 42.2245 40.0954 42.1394 39.9246C42.0544 39.7537 41.9309 39.6048 41.7786 39.4897L32.3922 32.3945Z",
    stroke: "#2F189C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1602 26.2227H40.5587",
    stroke: "#2F189C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3945 38.5667V32.3945",
    stroke: "#2F189C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4090:49428",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1449 32) scale(28.609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#BBF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1FAFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hour-glass.117e3468.svg";
export { ForwardRef as ReactComponent };